import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { VideoSettings } from '../../../../../../dorian-shared/types/video/video';

interface VideoSettingsFormProps {
  videoSettings: VideoSettings;
  stepIndex: number;
  isDisabled: boolean;
  onChange: (updatedSettings: VideoSettings) => void;
}

/**
 * VideoSettingsForm component for configuring video playback settings
 */
export function VideoSettingsForm({
  videoSettings,
  stepIndex,
  isDisabled,
  onChange,
}: VideoSettingsFormProps): React.ReactElement {
  const handleSettingChange = (settingName: keyof VideoSettings, value: boolean | number) => {
    const updatedSettings: VideoSettings = {
      ...videoSettings,
      [settingName]: value,
    };

    // We force "Allow Step Actions" to be true if "Loop" is not 0
    const isLoop = Boolean(updatedSettings.loop);

    const newSettings: VideoSettings = {
      ...updatedSettings,
      allowStepActions: isLoop || updatedSettings.allowStepActions,
    };
    onChange(newSettings);
  };

  const isAllowStepActionsDisabled = isDisabled || Boolean(videoSettings.loop);

  return (
    <Col className="d-flex align-items-center">

      <Form.Check
        custom
        disabled={isDisabled}
        checked={!!videoSettings.loop}
        id={`steps[${stepIndex}][video][videoSettings][loop]`}
        onChange={(event) => handleSettingChange('loop', event.target.checked ? -1 : 0)}
        label="Loop"
      />

      <Form.Check
        custom
        className="ml-3"
        id={`steps[${stepIndex}][video][videoSettings][allowStepActions]`}
        disabled={isAllowStepActionsDisabled}
        checked={!!videoSettings.allowStepActions}
        onChange={(e) => handleSettingChange('allowStepActions', e.target.checked)}
        type="checkbox"
        label="Allow Step Actions"
      />

      {/* Added hidden input to store the videoSettings in the form */}
      <input
        type="hidden"
        name={`steps[${stepIndex}][video][videoSettings]`}
        value={JSON.stringify(videoSettings)}
        data-testid={`video-settings-hidden-input-${stepIndex}`}
      />
    </Col>
  );
}
